import script from "./TermsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsPage.vue?vue&type=script&setup=true&lang=js"

import "./TermsPage.vue?vue&type=style&index=0&id=d27ebf0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d27ebf0e"]])

export default __exports__